import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DeckQuestion } from '../../strategy-deck.models';
import {CheckIconComponent} from '../../../../../shared/components/icons/check-icon/check-icon.component';

@Component({
  selector: 'app-deck-research-question',
  imports: [
    CheckIconComponent
  ],
  templateUrl: './deck-research-question.component.html',
  styleUrl: './deck-research-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeckResearchQuestionComponent {

  @Input({ required: true }) question!: DeckQuestion;
}
